/** Backend-classified QuickBooks validation reasons for bills. */
export enum BillSyncErrorReasonDTO {
  VENDOR_NOT_AVAILABLE = 'VENDOR_NOT_AVAILABLE',
  PROJECT_NOT_AVAILABLE = 'PROJECT_NOT_AVAILABLE',
  PRODUCT_OR_SERVICE_NOT_AVAILABLE = 'PRODUCT_OR_SERVICE_NOT_AVAILABLE',
  VENDOR_CURRENCY_MISMATCH = 'VENDOR_CURRENCY_MISMATCH',
  CURRENCY_NOT_ENABLED = 'CURRENCY_NOT_ENABLED',
  ACCOUNTING_PERIOD_CLOSED = 'ACCOUNTING_PERIOD_CLOSED',
  NEGATIVE_LINE_AMOUNT_NOT_ALLOWED = 'NEGATIVE_LINE_AMOUNT_NOT_ALLOWED',
  LINE_DESCRIPTION_TOO_LONG = 'LINE_DESCRIPTION_TOO_LONG',
  TRANSACTION_DATE_NOT_ALLOWED = 'TRANSACTION_DATE_NOT_ALLOWED',
  LINE_VALUE_OUT_OF_RANGE = 'LINE_VALUE_OUT_OF_RANGE',
  DATA_REJECTED = 'DATA_REJECTED',
}

export type BillSyncErrorReasonResponse = BillSyncErrorReasonDTO;
